<div
  class="fl w-100 dn db-ns"
  *ngIf="flightTrackerText$ | async as flightTrackerText"
>
  <span class="clip">{{ flightTrackerText?.tabletStickyStatus }}</span>
  <div
    *ngIf="leg?.flightStatus | jbIncludesSubstring: 'DELAY'"
    class="fl w-100 ph7 pv2 core-blue"
  >
    {{ flightTrackerText?.flightDelayedMsg }}
  </div>
  <div
    *ngIf="leg?.flightStatus | jbIncludesSubstring: 'NOW'"
    class="fl w-100 ph7 pv2 core-blue"
  >
    {{ flightTrackerText?.newOriginMsg }} {{ leg?.scheduledOriginAirport
    }}{{ flightTrackerText?.newOriginPeriod }}
  </div>
  <span
    *ngIf="leg?.flightStatus | jbIncludesSubstring: 'CANCELLED'"
    class="fl pv1 half-percent-column"
  ></span>
  <span
    *ngIf="!(leg?.flightStatus | jbIncludesSubstring: 'CANCELLED')"
    class="fl pv1 one-percent-column"
  ></span>
  <span class="fl w-20 pv1"></span>
  <div
    *ngIf="leg?.flightStatus | jbIncludesSubstring: 'CANCELLED'"
    class="fl animation-messaging pv1 core-blue"
  >
    {{ flightTrackerText?.flightCancelledMsgPrefix }}
    <a [jbSitemapLinker]="'/contact-us'">{{ flightTrackerText?.contactUs }}</a>
    {{ flightTrackerText?.forAssistance }}
  </div>
  <jb-flight-tracker-results-animation
    [flightLegData]="leg"
  ></jb-flight-tracker-results-animation>
  <span class="fl pv1 one-percent-column"></span>
  <span class="fl pv1 one-percent-column"></span>
  <span class="fl pv1 five-percent-column"></span>
</div>
